export default {
  // item
  active: 'Pesan Sekarang',
  upcoming: 'Segera hadir',
  disabled: 'Gangguan',
  onhold: 'Gangguan',
  // transaction
  unknown: 'unknown',
  pending: 'Diproses',
  inprogress: 'Diproses',
  'on-delivery': 'Sedang dikirim',
  success: 'Selesai',
  done: 'Selesai',
  expired: 'Kedaluwarsa',
  rejected: 'Dikembalikan',
  failed: 'Gagal',
};
